import { render, staticRenderFns } from "./LmUploadImage.vue?vue&type=template&id=19b50e1f&scoped=true"
import script from "./LmUploadImage.vue?vue&type=script&lang=js"
export * from "./LmUploadImage.vue?vue&type=script&lang=js"
import style0 from "./LmUploadImage.vue?vue&type=style&index=0&id=19b50e1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b50e1f",
  null
  
)

export default component.exports